import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@repo-level/core-front';
import QRCode from 'react-qr-code';

import { FormGroup } from 'components/form/groups/FormGroup';
import { OfUnion } from 'types/common';
import { PaymentMethodContext } from '../providers';

import { ScCryptoBlock } from './styled';
import { ScQRCode } from 'components/form/QRCode/styled';

export const FieldDepositCryptoAddress: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.DepositCryptoAddress]
> = ({ label, fieldName, address }) => {
  const { t } = useTranslation(['glossary', 'deposits']);

  const { currency } = useContext(PaymentMethodContext);

  return (
    <FormGroup title={label || fieldName}>
      <ScCryptoBlock>
        <div className="details">{t('deposits:fields.crypto.text1')}</div>
        {!!address && (
          <ScQRCode>
            <QRCode value={address} size={106} />
          </ScQRCode>
        )}
        <div className="details">
          {t('deposits:fields.crypto.text2', { currency })}
          <br />
          <span className="wallet">{address}</span>
        </div>
      </ScCryptoBlock>
    </FormGroup>
  );
};
